const _excluded = ["onBlur", "onChange"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import { useEffect, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { nonNegativeNumberValidation } from 'validators';
import { InfoIcon, TextField } from 'seagull';
import { positiveQuantityInputProps } from "../../constants";
import { useFeatureFlags } from "../../hooks/useFeatureFlags";
import pluralize from "../../utils/pluralize";
import { connectControllerToTextField } from "../../utils/react-hook-form.utils";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export default function PreapprovedTextField(_ref) {
  let {
    suffix
  } = _ref;
  const {
    control,
    watch
  } = useFormContext();
  const [isFocused, setIsFocused] = useState(false);
  const [isInfoOpen, setIsInfoOpen] = useState(false);
  const unitCap = watch('unitCap');
  const unitName = watch('unitName');
  const pricing = watch('pricing');
  const {
    PREAPPROVED_AMOUNT_IMPROVMENTS = false
  } = useFeatureFlags();
  useEffect(() => {
    setIsInfoOpen(isFocused && !!unitCap && +unitCap === 0);
  }, [isFocused, unitCap]);
  const validate = value => {
    if (PREAPPROVED_AMOUNT_IMPROVMENTS) {
      if (!value || +value <= 0) return 'Set cap (greater than 0)';
      return nonNegativeNumberValidation('Set cap (greater than 0)')(value);
    }
    return nonNegativeNumberValidation('Set cap (0 or higher)')(value);
  };
  const getLabel = () => {
    if (PREAPPROVED_AMOUNT_IMPROVMENTS) {
      return "Preapproved amount";
    }
    return "Preapproved ".concat(pricing === 'unit' ? pluralize(unitName) || 'units' : pricing === 'hour' ? 'hours' : '');
  };
  return /*#__PURE__*/_jsx(Controller, {
    control: control,
    name: "unitCap",
    rules: {
      validate
    },
    render: renderProps => {
      const _connectControllerToT = connectControllerToTextField(renderProps),
        {
          onBlur: _onBlur,
          onChange: _onChange
        } = _connectControllerToT,
        rest = _objectWithoutProperties(_connectControllerToT, _excluded);
      return /*#__PURE__*/_jsx(TextField, _objectSpread(_objectSpread({
        collapseHelperText: false,
        style: {
          width: '50%'
        },
        isMoney: true,
        alwaysShrinkLabel: true,
        inputProps: positiveQuantityInputProps,
        testid: "sb-cap",
        label: getLabel(),
        onFocus: () => setIsFocused(true),
        onChange: e => {
          const trimmedValue = e.target.value.slice(0, 7);
          _onChange({
            target: {
              value: trimmedValue
            }
          });
        },
        onBlur: () => {
          setIsFocused(false);
          _onBlur();
        }
      }, rest), {}, {
        suffix: PREAPPROVED_AMOUNT_IMPROVMENTS ? /*#__PURE__*/_jsx(_Fragment, {
          children: suffix && /*#__PURE__*/_jsx("span", {
            "data-testid": "sb-cap-suffix",
            children: suffix
          })
        }) : /*#__PURE__*/_jsx(InfoIcon, {
          forceOpen: isInfoOpen,
          "data-testid": "sb-cap-info",
          info: /*#__PURE__*/_jsx("div", {
            "data-testid": "sb-cap-tooltip",
            children: "Payments up to the set amount don't require client approval. If you input 0, or a payment exceeds the set limit, client approval will be required for the payment."
          })
        })
      }));
    }
  });
}